import React from 'react';

export const DimensionContext = React.createContext({});
